var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotice = function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    fillRule: "evenodd",
    d: "M14 22.3333C18.6024 22.3333 22.3333 18.6024 22.3333 14C22.3333 9.39763 18.6024 5.66667 14 5.66667C9.39763 5.66667 5.66667 9.39763 5.66667 14C5.66667 18.6024 9.39763 22.3333 14 22.3333ZM14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M14.9134 8L14.7624 16.4702H13.1543L13.0033 8H14.9134ZM13.9612 20C13.64 20 13.3652 19.8878 13.1369 19.6633C12.9085 19.4349 12.7963 19.1601 12.8001 18.8389C12.7963 18.5215 12.9085 18.2506 13.1369 18.0261C13.3652 17.7978 13.64 17.6836 13.9612 17.6836C14.2747 17.6836 14.5457 17.7978 14.774 18.0261C15.0024 18.2506 15.1185 18.5215 15.1224 18.8389C15.1185 19.0518 15.0624 19.2472 14.954 19.4253C14.8495 19.5994 14.7102 19.7388 14.536 19.8433C14.3618 19.9477 14.1702 20 13.9612 20Z"
  })));
};
export default SvgNotice;